import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Conseil";
const heroImage = "https://net-basis.net/Bilder/ict-market-entry-consulting-strategy-dach.webp";
const heroAlt = "Des professionnels analysent des données pour l'entrée, la vente et le marketing sur le marché DACH.";
const heroClaimLine1 = "En toute sécurité sur";
const heroClaimLine2 = "les nouveaux marchés !";
const claimText = "Votre partenaire de conseil stratégique pour une entrée ciblée sur le marché de la région DACH. Nous transformons une expertise approfondie en solutions pragmatiques afin de développer vos activités commerciales internationales de manière efficace et durable.";
const benefitsTitle = "Comment vous profitez de notre expertise en __conseil__ :";
const p1Text = "NetBasis International propose une gamme complète de services de conseil. Grâce à un savoir-faire solide et à une compréhension profonde de l'activité de nos partenaires, nous développons des stratégies sur mesure pour une expansion réussie et une réalisation rapide de vos objectifs commerciaux.";
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Évaluation approfondie des potentiels commerciaux spécifiques sur les marchés cibles",
  "Définition stratégique de l'entrée optimale sur le marché",
  "Adaptation précise aux différences environnementales des nouveaux espaces économiques",
  "Conseil expert pour la définition des objectifs commerciaux de nos partenaires constructeurs",
  "Création de plans de vente et de marketing efficaces pour atteindre les objectifs en toute sécurité",
  "Soutien opérationnel dans la planification et la mise en œuvre de toutes les étapes nécessaires",
  "Conseil en gestion pratique pour les questions d'intégration interculturelle",
  "Développement de stratégies de négociation élaborées et accompagnement lors de leur réalisation",
  "Coordination efficace et collaboration avec des partenaires commerciaux potentiels tels que les constructeurs, les distributeurs ou les revendeurs",
];

export default function ConseilFrPage() {
  const strongName = COMPANY_NAME;
  const p1Parts = p1Text.split(strongName);

  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Conseil aux Entreprises | NetBasis International"
        description="Conseil stratégique pour optimiser vos structures de vente et implanter durablement des marques étrangères."
        ogUrl="https://net-basis.net/fr/services/conseil"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[8%] md:pt-[5%] lg:pt-[5%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center globus-text-slide"
                  style={{
                    fontFamily: '"Open Sans", sans-serif',
                  }}
                >
                  <span className="block md:hidden">{heroClaimLine1}</span>
                  <span className="block md:hidden">{heroClaimLine2}</span>
                  <span className="hidden md:block">{heroClaimLine1} {heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <h1 className="text-sm md:text-base font-semibold text-foreground-950 mb-4 font-sans">
                {claimText}
              </h1>
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{strongName}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Benefits heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}